
export default {
  areaCode_China: '中国',
  areaCode_Macau: '中国澳门',
  areaCode_Taiwan: '中国台湾',
  areaCode_HongKong: '中国香港',
  areaCode_Albania: '阿尔巴尼亚',
  areaCode_Algeria: '阿尔及利亚',
  areaCode_Afghanistan: '阿富汗',
  areaCode_Argentina: '阿根廷',
  areaCode_UnitedArabEmirates: '阿拉伯联合酋长国',
  areaCode_Aruba: '阿鲁巴',
  areaCode_Oman: '阿曼',
  areaCode_Azerbaijan: '阿塞拜疆',
  areaCode_Egypt: '埃及',
  areaCode_Ethiopia: '埃塞俄比亚',
  areaCode_Ireland: '爱尔兰',
  areaCode_Estonia: '爱沙尼亚',
  areaCode_Andorra: '安道尔',
  areaCode_Angola: '安哥拉',
  areaCode_Anguilla: '安圭拉',
  areaCode_AntiguaAndBarbuda: '安提瓜和巴布达',
  areaCode_Austria: '奥地利',
  areaCode_Australia: '澳大利亚',
  areaCode_Barbados: '巴巴多斯',
  areaCode_PapuaNewGuinea: '巴布亚新几内亚',
  areaCode_Bahamas: '巴哈马',
  areaCode_Pakistan: '巴基斯坦',
  areaCode_Paraguay: '巴拉圭',
  areaCode_Palestine: '巴勒斯坦',
  areaCode_Bahrain: '巴林',
  areaCode_Panama: '巴拿马',
  areaCode_Brazil: '巴西',
  areaCode_Belarus: '白俄罗斯',
  areaCode_Bermuda: '百慕大群岛',
  areaCode_Bulgaria: '保加利亚',
  areaCode_Benin: '贝宁',
  areaCode_Belgium: '比利时',
  areaCode_Iceland: '冰岛',
  areaCode_PuertoRico: '波多黎各',
  areaCode_Poland: '波兰',
  areaCode_BosniaandHerzegovina: '波斯尼亚和黑塞哥维',
  areaCode_Bolivia: '玻利维亚',
  areaCode_Belize: '伯利兹',
  areaCode_Botswana: '博茨瓦纳',
  areaCode_Bhutan: '不丹',
  areaCode_BurkinaFaso: '布基纳法索',
  areaCode_Burundi: '布隆迪',
  areaCode_EquatorialGuinea: '赤道几内亚',
  areaCode_Denmark: '丹麦',
  areaCode_Germany: '德国',
  areaCode_TimorLeste: '东帝汶',
  areaCode_Togo: '多哥',
  areaCode_Dominica: '多米尼加',
  areaCode_DominicanRepublic: '多米尼加共和国',
  areaCode_Russia: '俄罗斯',
  areaCode_Ecuador: '厄瓜多尔',
  areaCode_Eritrea: '厄立特里亚',
  areaCode_France: '法国',
  areaCode_FaroeIslands: '法罗群岛',
  areaCode_FrenchPolynesia: '法属波利尼西亚',
  areaCode_FrenchGuiana: '法属圭亚那',
  areaCode_Philippines: '菲律宾',
  areaCode_Fiji: '斐济',
  areaCode_Finland: '芬兰',
  areaCode_Gambia: '冈比亚',
  areaCode_RepublicOfTheCongo: '刚果共和国',
  areaCode_DemocraticRepublicof: '刚果民主共和国',
  areaCode_Colombia: '哥伦比亚',
  areaCode_CostaRica: '哥斯达黎加',
  areaCode_Grenada: '格林纳达',
  areaCode_Greenland: '格陵兰岛',
  areaCode_Georgia: '格鲁吉亚',
  areaCode_Cuba: '古巴',
  areaCode_Guadeloupe: '瓜德罗普岛',
  areaCode_Guatemala: '瓜地马拉',
  areaCode_Guam: '关岛',
  areaCode_Guyana: '圭亚那',
  areaCode_Kazakhstan: '哈萨克斯坦',
  areaCode_Haiti: '海地',
  areaCode_SouthKorea: '韩国',
  areaCode_Netherlands: '荷兰',
  areaCode_Montenegro: '黑山',
  areaCode_Honduras: '洪都拉斯',
  areaCode_Djibouti: '吉布提',
  areaCode_Kiribati: '基里巴斯',
  areaCode_Kyrgyzstan: '吉尔吉斯斯坦',
  areaCode_Guinea: '几内亚',
  areaCode_GuineaBissau: '几内亚比绍共和国',
  areaCode_Canada: '加拿大',
  areaCode_Ghana: '加纳',
  areaCode_Gabon: '加蓬',
  areaCode_Cambodia: '柬埔寨',
  areaCode_Czech: '捷克',
  areaCode_Zimbabwe: '津巴布韦',
  areaCode_Cameroon: '喀麦隆',
  areaCode_Qatar: '卡塔尔',
  areaCode_CaymanIslands: '开曼群岛',
  areaCode_CapeVerde: '开普',
  areaCode_Comoros: '科摩罗',
  areaCode_Kuwait: '科威特',
  areaCode_Croatia: '克罗地亚',
  areaCode_Kenya: '肯尼亚',
  areaCode_CookIslands: '库克群岛',
  areaCode_Curacao: '库拉索',
  areaCode_Latvia: '拉脱维亚',
  areaCode_Lesotho: '莱索托',
  areaCode_Laos: '老挝',
  areaCode_Lebanon: '黎巴嫩',
  areaCode_Lithuania: '立陶宛',
  areaCode_Liberia: '利比里亚',
  areaCode_Libya: '利比亚',
  areaCode_Liechtenstein: '列支敦士登',
  RéunionIsland: '留尼汪',
  areaCode_Luxembourg: '卢森堡',
  areaCode_Rwanda: '卢旺达',
  areaCode_Romania: '罗马尼亚',
  areaCode_Madagascar: '马达加斯加',
  areaCode_Maldives: '马尔代夫',
  areaCode_Malta: '马耳他',
  areaCode_Malawi: '马拉维',
  areaCode_Malaysia: '马来西亚',
  areaCode_Mali: '马里',
  areaCode_Macedonia: '马其顿',
  areaCode_Martinique: '马提尼克',
  areaCode_Mayotte: '马约特',
  areaCode_Mauritius: '毛里求斯',
  areaCode_Mauritania: '毛里塔尼亚',
  areaCode_UnitedStates: '美国',
  areaCode_AmericanSamoa: '美属萨摩亚',
  areaCode_VirginIslandsUS: '美属维尔京群岛',
  areaCode_Mongolia: '蒙古',
  areaCode_Montserrat: '蒙特塞拉特岛',
  areaCode_Bangladesh: '孟加拉国',
  areaCode_Peru: '秘鲁',
  areaCode_Myanmar: '缅甸',
  areaCode_Moldova: '摩尔多瓦',
  areaCode_Morocco: '摩洛哥',
  areaCode_Monaco: '摩纳哥',
  areaCode_Mozambique: '莫桑比克',
  areaCode_Mexico: '墨西哥',
  areaCode_Namibia: '纳米比亚',
  areaCode_SouthAfrica: '南非',
  areaCode_Nepal: '尼泊尔',
  areaCode_Nicaragua: '尼加拉瓜',
  areaCode_Niger: '尼日尔',
  areaCode_Nigeria: '尼日利亚',
  areaCode_Norway: '挪威',
  areaCode_Palau: '帕劳',
  areaCode_Portugal: '葡萄牙',
  areaCode_Japan: '日本',
  areaCode_Sweden: '瑞典',
  areaCode_Switzerland: '瑞士',
  areaCode_ElSalvador: '萨尔瓦多',
  areaCode_Samoa: '萨摩亚',
  areaCode_Serbia: '塞尔维亚',
  areaCode_SierraLeone: '塞拉利昂',
  areaCode_Senegal: '塞内加尔',
  areaCode_Cyprus: '塞浦路斯',
  areaCode_Seychelles: '塞舌尔',
  areaCode_SaudiArabia: '沙特阿拉伯',
  areaCode_SaintPierreandMiquel: '圣彼埃尔和密克隆岛',
  areaCode_SaoTomeandPrincipe: '圣多美和普林西比',
  areaCode_SaintKittsandNevis: '圣基茨和尼维斯',
  areaCode_SaintLucia: '圣露西亚',
  areaCode_SintMaartenDutchPar: '圣马丁岛（荷兰部分',
  areaCode_SanMarino: '圣马力诺',
  areaCode_SaintVincentandTheG: '圣文森特和格林纳丁',
  areaCode_SriLanka: '斯里兰卡',
  areaCode_Slovakia: '斯洛伐克',
  areaCode_Slovenia: '斯洛文尼亚',
  areaCode_Swaziland: '斯威士兰',
  areaCode_Sudan: '苏丹',
  areaCode_Suriname: '苏里南',
  areaCode_SolomonIslands: '所罗门群岛',
  areaCode_Somalia: '索马里',
  areaCode_Tajikistan: '塔吉克斯坦',
  areaCode_Thailand: '泰国',
  areaCode_Tanzania: '坦桑尼亚',
  areaCode_Tonga: '汤加',
  areaCode_TurksandCaicosIsland: '特克斯和凯科斯群岛',
  areaCode_TrinidadandTobago: '特立尼达和多巴哥',
  areaCode_Tunisia: '突尼斯',
  areaCode_Turkey: '土耳其',
  areaCode_Turkmenistan: '土库曼斯坦',
  areaCode_Vanuatu: '瓦努阿图',
  areaCode_Venezuela: '委内瑞拉',
  areaCode_Brunei: '文莱',
  areaCode_Uganda: '乌干达',
  areaCode_Ukraine: '乌克兰',
  areaCode_Uruguay: '乌拉圭',
  areaCode_Uzbekistan: '乌兹别克斯坦',
  areaCode_Spain: '西班牙',
  areaCode_Greece: '希腊',
  areaCode_IvoryCoast: '象牙海岸',
  areaCode_Singapore: '新加坡',
  areaCode_NewCaledonia: '新喀里多尼亚',
  areaCode_NewZealand: '新西兰',
  areaCode_Hungary: '匈牙利',
  areaCode_Syria: '叙利亚',
  areaCode_Jamaica: '牙买加',
  areaCode_Armenia: '亚美尼亚',
  areaCode_Yemen: '也门',
  areaCode_Iraq: '伊拉克',
  areaCode_Iran: '伊朗',
  areaCode_Israel: '以色列',
  areaCode_Italy: '意大利',
  areaCode_India: '印度',
  areaCode_Indonesia: '印度尼西亚',
  areaCode_UnitedKingdom: '英国',
  areaCode_VirginIslandsBritish: '英属处女群岛',
  areaCode_Jordan: '约旦',
  areaCode_Vietnam: '越南',
  areaCode_Zambia: '赞比亚',
  areaCode_Chad: '乍得',
  areaCode_Gibraltar: '直布罗陀',
  areaCode_Chile: '智利',
  areaCode_CentralAfricanRepubli: '中非共和国',
}
